// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI, { Link } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts 

import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.use(ElementUI);
import { msg,post, get, upLoad,formatDate,CountDown,downFile } from './util/request.js'

Vue.prototype.$msg = msg//消息提示
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$CountDown = CountDown
Vue.prototype.$upload = upLoad
Vue.prototype.$downFile = downFile
Vue.prototype.$formatDate = formatDate
Vue.config.productionTip = false


router.beforeEach((to, form, next) => {
	window.document.title = to.meta.title == undefined ? '智培盟网校|在线学习平台|供应链课程|CPPM课程|SCMP课程' : to.meta.title
	// 让页面回到顶部
	 document.documentElement.scrollTop = 0
	 // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
	next()
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js